/**
 * NOTE: Please ensure the SCSS definitions are kept up to date if these change
 * ./colours.scss
 */
const PrimaryAccent = '#ffbc00';

export default {
  PrimaryAccent,
};
